import { FloatingContact, Header, Footer } from "../components/site-shell";
import { PageTransition } from "../components/page-transition";
import { serializeJsonLd, siteName, siteUrl } from "../lib/seo";
import { siteConfig } from "../lib/site-config";
import "./globals.css";

export const metadata = {
  metadataBase: new URL(siteUrl),
  title: {
    default: "增长深度 GrowDeep｜企业品牌增长与产品出海",
    template: "%s｜增长深度 GrowDeep",
  },
  description: siteConfig.brand.description,
  applicationName: siteName,
  authors: [{ name: siteName, url: siteUrl }],
  creator: siteName,
  publisher: siteName,
  category: "企业品牌增长与产品出海服务",
  formatDetection: { email: false, address: false, telephone: false },
};

const organizationJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${siteUrl}/#organization`,
      name: siteName,
      alternateName: ["增长深度", "GrowDeep"],
      url: siteUrl,
      logo: `${siteUrl}${siteConfig.brand.logo}`,
      description:
        "面向企业提供品牌增长、产品出海、官网与独立站、内容增长、SEO、GEO 和持续运营服务。",
      email: siteConfig.contact.email,
      telephone: siteConfig.contact.phone.international,
      address: {
        "@type": "PostalAddress",
        addressLocality: siteConfig.contact.city,
        addressRegion: siteConfig.contact.region,
        addressCountry: "CN",
      },
      contactPoint: {
        "@type": "ContactPoint",
        telephone: siteConfig.contact.phone.international,
        contactType: "customer service",
        areaServed: ["CN", "Worldwide"],
        availableLanguage: ["zh-CN", "en"],
      },
      knowsAbout: [
        "企业品牌增长",
        "产品出海",
        "企业官网建设",
        "海外独立站",
        "SEO",
        "GEO",
        "内容增长",
      ],
    },
    {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`,
      url: siteUrl,
      name: siteName,
      inLanguage: "zh-CN",
      publisher: { "@id": `${siteUrl}/#organization` },
    },
  ],
};

export default function RootLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: serializeJsonLd(organizationJsonLd),
        }}
      />
      <PageTransition>
        {children}
      </PageTransition>
    </>
  );
}

export function SiteLayout({
  children,
}: Readonly<{ children: React.ReactNode }>) {
  return (
    <PageTransition>
      <Header />
      <main>{children}</main>
      <FloatingContact />
      <Footer />
    </PageTransition>
  );
}
